import { DialogComponent } from '@theme/dialog';
import { CartAddEvent , ThemeEvents} from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
connectedCallback() {
    super.connectedCallback();

this.refreshRecommendations();


// Listen for NEW items added (from Product Form)
  window.addEventListener(CartAddEvent.eventName, (event) => {
    this.#handleCartAdd();
    const productId = event.detail.data?.productId || event.detail.data?.id;
    if (productId) this.refreshRecommendations(productId);
  });

  // NEW: Listen for cart CHANGES (quantity update / delete)
  // This ensures that when the section morphs, we put the recommendations back
  window.addEventListener(ThemeEvents.cartUpdate, (event) => {
    console.log('Cart updated, refreshing recommendations...');
    this.refreshRecommendations();
  });

  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

/**
 * Updates recommendations based on a specific product or the first item in cart.
 * Handles Swiper destruction and re-initialization to ensure smooth physics.
 * * @param {string} [productId] - Optional: The ID to base recommendations on.
 */
refreshRecommendations(productId) {
  const container = this.querySelector('cart-recommendations-component');
  if (!container) return;

  // 1. Set loading state (optional: for fade effects)
  container.classList.add('is-loading');

  let url = container.dataset.url;

  // 2. Build the dynamic URL if a productId is provided
  if (productId) {
    const baseUrl = url.split('?')[0];
    const params = new URLSearchParams(url.split('?')[1]);
    const sectionId = params.get('section_id') || this.dataset.sectionId;
    
    url = `${baseUrl}?section_id=${sectionId}&product_id=${productId}&limit=6`;
  }

  fetch(url)
    .then(response => response.text())
    .then(html => {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      const newComponent = parsedHTML.querySelector('cart-recommendations-component');
      
      if (newComponent && newComponent.innerHTML.trim().length > 0) {
        // 3. Clean up the existing Swiper instance before replacing DOM
        if (container.swiper && typeof container.swiper.destroy === 'function') {
          container.swiper.destroy(true, true);
        }

        // 4. Update the DOM and the data-url for future consistency
        container.innerHTML = newComponent.innerHTML;
        container.dataset.url = url;

        // 5. Re-initialize Swiper
        // We use a small timeout to ensure the browser has painted the new nodes
        setTimeout(() => {
          if (typeof container.initSwiper === 'function') {
            container.initSwiper();
          }
          container.classList.remove('is-loading');
        }, 10);
      } else {
        // Hide container if no recommendations found
        container.style.display = 'none';
      }
    })
    .catch(err => {
      console.error("Cart Recommendations Error:", err);
      container.classList.remove('is-loading');
    });
}

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
